var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13251_7538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7737 18.5527C12.7727 18.7528 12.6928 18.9445 12.5512 19.086C12.4097 19.2275 12.2181 19.3074 12.0179 19.3084C11.8185 19.3051 11.6283 19.2244 11.4873 19.0834C11.3463 18.9423 11.2656 18.7521 11.2622 18.5527L11.2688 12.7558L5.47199 12.7625C5.27261 12.7591 5.08233 12.6784 4.94132 12.5374C4.80032 12.3964 4.71962 12.2061 4.71627 12.0067C4.71723 11.8066 4.79716 11.6149 4.93868 11.4734C5.0802 11.3319 5.27186 11.252 5.47199 11.251L11.2688 11.2577L11.2622 5.4608C11.2807 5.27319 11.3683 5.09916 11.508 4.97256C11.6476 4.84596 11.8294 4.77584 12.0179 4.77584C12.2065 4.77584 12.3882 4.84596 12.5279 4.97256C12.6676 5.09916 12.7552 5.27319 12.7737 5.4608L12.767 11.2577L18.5639 11.251C18.7515 11.2695 18.9255 11.3571 19.0521 11.4968C19.1787 11.6365 19.2488 11.8182 19.2488 12.0067C19.2488 12.1953 19.1787 12.377 19.0521 12.5167C18.9255 12.6564 18.7515 12.744 18.5639 12.7625L12.767 12.7558L12.7737 18.5527Z",
    fill: "#18397A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13251_7538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlue);
export default __webpack_public_path__ + "static/media/plusBlue.d64c5ddb15bfc3af68f6dafd897def47.svg";
export { ForwardRef as ReactComponent };